import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule, FlexModule } from '@ngbracket/ngx-layout';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';

import { ToastModule } from '@libs/src/toast/toast.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';

import { SettingsPersonalEmailChangeComponent } from './settings-personal-email-change.component';

@NgModule({
  declarations: [SettingsPersonalEmailChangeComponent],
  exports: [SettingsPersonalEmailChangeComponent],
  imports: [
    CommonModule,
    ExtendedModule,
    FlexModule,
    MatIconModule,
    NzFormModule,
    NzInputModule,
    ReactiveFormsModule,
    ToastModule,
    TtcButtonSharedModule,
  ],
})
export class SettingsPersonalEmailChangeModule {}
